import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Office = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="office icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 28.395H46V41.395C46 43.0519 44.6569 44.395 43 44.395H5C3.34315 44.395 2 43.0519 2 41.395V28.395ZM4 30.395V41.395C4 41.9473 4.44772 42.395 5 42.395H43C43.5523 42.395 44 41.9473 44 41.395V30.395H4Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 25.395C0 23.7382 1.34315 22.395 3 22.395H45C46.6569 22.395 48 23.7382 48 25.395V27.395C48 29.0519 46.6569 30.395 45 30.395H3C1.34314 30.395 0 29.0519 0 27.395V25.395ZM3 24.395C2.44772 24.395 2 24.8427 2 25.395V27.395C2 27.9473 2.44772 28.395 3 28.395H45C45.5523 28.395 46 27.9473 46 27.395V25.395C46 24.8427 45.5523 24.395 45 24.395H3Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 23.395C25 18.9767 28.5817 15.395 33 15.395H36C40.4183 15.395 44 18.9767 44 23.395H43V24.395H26V23.395H25ZM27.083 22.395H41.917C41.441 19.5573 38.973 17.395 36 17.395H33C30.027 17.395 27.559 19.5573 27.083 22.395Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6.39502H24V20.395H4V6.39502ZM6 8.39502V18.395H22V8.39502H6Z"
    />
    <path className={pathClass} d="M13 19.395H15V23.395H13V19.395Z" />
    <path className={pathClass} d="M13 10.395H15V16.395H13V10.395Z" />
    <path className={pathClass} d="M11 12.395H17V14.395H11V12.395Z" />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.5 8.39502C29.5 5.6336 31.7386 3.39502 34.5 3.39502C37.2614 3.39502 39.5 5.6336 39.5 8.39502V9.89502C39.5 12.6564 37.2614 14.895 34.5 14.895C31.7386 14.895 29.5 12.6564 29.5 9.89502V8.39502ZM34.5 5.39502C32.8431 5.39502 31.5 6.73817 31.5 8.39502V9.89502C31.5 11.5519 32.8431 12.895 34.5 12.895C36.1569 12.895 37.5 11.5519 37.5 9.89502V8.39502C37.5 6.73817 36.1569 5.39502 34.5 5.39502Z"
    />
  </svg>
)
